.root {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.list {
  display: flex;
  flex: none;
  gap: var(--space-1);
  padding: 0 var(--space-2);
  border-bottom: var(--border-width) solid var(--color-border);
}

.trigger {
  position: relative;
  display: inline-flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: var(--space-1-5);
  min-width: 0;
  height: var(--control-md);
  padding: 0 var(--space-3);
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
}

.trigger:hover {
  color: var(--color-text);
}

.trigger[data-state="active"] {
  color: var(--color-text);
}

.trigger[data-state="active"]::after {
  content: "";
  position: absolute;
  inset-inline: var(--space-3);
  bottom: -1px;
  height: 2px;
  border-radius: var(--radius-full);
  background: var(--color-accent);
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: var(--radius-full);
  background: var(--color-accent);
  color: var(--color-on-accent);
  font-size: 0.6875rem;
  font-weight: var(--weight-semibold);
  line-height: 18px;
  font-variant-numeric: tabular-nums;
}

.panel {
  flex: 1;
  min-height: 0;
  outline: none;
}

/* Panels kept mounted (forceMount) stay in the DOM while inactive; only the active one shows. */
.panel[hidden],
.panel[data-state="inactive"] {
  display: none;
}
